'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Optionally log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className='flex min-h-[400px] flex-col items-center justify-center space-y-4'>
      <h2 className='text-xl font-semibold text-gray-900'>
        Something went wrong!
      </h2>
      <p className='text-gray-600'>
        {error.message || 'There was an error processing your request.'}
      </p>
      <button
        onClick={reset}
        className='rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-blue-500'
      >
        Try again
      </button>
    </div>
  );
}
